import React from 'react';
import BigButton from '../../../components/BigButton';
import {APP_NAME, CONTACT_EMAIL} from '../../../constants';

class TalkToSalesButton extends React.Component {

  onClick = () => {
    const subject = `subject=${APP_NAME} Inquiry`;
    window.location.href = `mailto:${CONTACT_EMAIL}?${subject}`;
  };

  render() {
    return <BigButton
      text="CONTACT US"
      onClick={this.onClick}
    />;
  }
}

TalkToSalesButton.propTypes = {};

export default TalkToSalesButton;



// WEBPACK FOOTER //
// ./src/containers/Buttons/TalkToSalesButton/index.js